import type { DaycareHotelMode } from "@/hooks/useDaycareHotelAccess";

export function getStayHistoryFilter(
  mode: DaycareHotelMode,
  t: (key: string) => string,
): { value: "stay"; label: string } | null {
  if (mode === "none") return null;
  if (mode === "daycare") return { value: "stay", label: t("historyTab.stay.daycare") };
  if (mode === "hotel") return { value: "stay", label: t("historyTab.stay.hotel") };
  return { value: "stay", label: t("historyTab.stay.filterLabel") };
}
